<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>轮盘配置</span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:roulette:add']" size="mini" type="primary" @click="dialogVisible = true">添加等级</el-button>
            <clear-cache-apply />
            <sync-data />
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form>
                      </div>

                      <el-table :data="scoreItem.data" border stripe>
                        <el-table-column prop="free_time" label="免费旋转倒计时(分钟)">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.free_time" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="free_count" label="免费次数">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.free_count" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="star" label="获得星星数">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.star" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="skin" label="皮肤">
                          <template slot-scope="scope">
                            <el-input v-model="scope.row.skin" />
                          </template>
                        </el-table-column>
                        <el-table-column label="操作">
                          <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="visibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible = true">奖励配置</el-button>
                            <el-drawer title="奖励配置" :before-close="(d)=>{return handleClose(d, tabItem.label,scoreItem.group_name, scope.$index)}" size="1100px" :visible="visibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible">
                              <el-form :inline="true">
                                <el-row v-for="(config, i) in scope.row.reward" :key="i">
                                  <el-form-item label="ID" style="margin-top: 10px;">
                                    <el-input v-model.number="config.id" style="width: 60px;" placeholder="id" />
                                  </el-form-item>
                                  <el-form-item label="道具" style="margin-top: 10px;">
                                    <el-select v-model.number="config.prize.propsId" style="width: 100px;" placeholder="请选择" @change="v=>propChange(v,tabItem.label,scoreItem.group_name,scope.$index, i)">
                                      <el-option
                                        v-for="(item, index) in rewardType"
                                        :key="index"
                                        :label="item.label"
                                        :value="item.value"
                                      />
                                    </el-select>
                                  </el-form-item>
                                  <el-form-item v-if="skinMap[config.prize.propsId]" style="margin-top: 10px;" label="皮肤">
                                    <el-select v-model.number="config.prize.skin" placeholder="请选择" style="width: 120px">
                                      <el-option
                                        v-for="item in skinMap[config.prize.propsId]"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                      />
                                    </el-select>
                                  </el-form-item>
                                  <el-form-item v-else label="皮肤" style="margin-top: 10px;">
                                    <el-input v-model="config.prize.skin" style="width: 80px;" placeholder="皮肤" />
                                  </el-form-item>
                                  <el-form-item label="奖品数量" style="margin-top: 10px;">
                                    <el-input v-model.number="config.prize.num" :readonly="skinId.includes(config.prize.propsId)" style="width: 80px;" placeholder="奖品数量" />
                                  </el-form-item>
                                  <el-form-item style="margin-top: 10px;" label="金币取值">
                                    <el-select v-model.number="config.prize.rtype" :disabled="config.prize.propsId !== 14" placeholder="请选择" style="width: 120px">
                                      <el-option
                                        v-for="item in selectType"
                                        :key="item.id"
                                        :label="item.title"
                                        :value="item.id"
                                      />
                                    </el-select>
                                  </el-form-item>
                                  <el-form-item style="margin-top: 10px;" label="权重">
                                    <el-input v-model.number="config.v" style="width: 80px" placeholder="权重" autocomplete="off" />
                                  </el-form-item>
                                  <el-form-item style="margin-top: 10px;">
                                    <el-button v-permisaction="['config:roulette:del']" type="danger" @click="delReward(tabItem.label,scoreItem.group_name,scope.$index, i)">删除</el-button>
                                  </el-form-item>
                                </el-row>
                              </el-form>
                              <el-button v-permisaction="['config:roulette:add']" style="margin-top: 10px" type="primary" @click="addReward(tabItem.label,scoreItem.group_name, scope.$index)">+</el-button>
                              <div slot="footer" class="dialog-footer">
                                <el-button @click="visibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">取 消</el-button>
                                <el-button type="primary" @click="visibleArr[tabItem.label][scoreItem.group_name][scope.$index].visible = false">确 定</el-button>
                              </div>
                            </el-drawer>
                          </template>
                        </el-table-column>
                      </el-table>

                      <div style="margin:10px 0px;" />
                      <el-table :data="scoreItem.data[0].reward" border stripe>
                        <el-table-column prop="id" label="ID">
                          <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="propsId" label="道具">
                          <template slot-scope="scope">
                            <span>{{ getPropName(scope.row.prize.propsId) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="num" label="数量">
                          <template slot-scope="scope">
                            <span>{{ scope.row.prize.num }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="num" label="取值范围">
                          <template slot-scope="scope">
                            <span v-if="scope.row.prize.rtype ===1">只取数量</span>
                            <span v-else>等级取值</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="skin" label="皮肤">
                          <template slot-scope="scope">
                            <span>{{ getSkinName(scope.row.prize.propsId,scope.row.prize.skin) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="v" label="权重">
                          <template slot-scope="scope">
                            <span>{{ scope.row.v }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div style="margin:10px 0px;" />
                      <el-button v-if="scoreItem.data.length <= 0" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name)">+</el-button>
                      <el-button v-permisaction="['config:roulette:add']" type="primary" @click="onSubmit()">保存</el-button>

                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getRewardType } from '@/api/config/slot'
import { delRouletteCfgList, getRouletteCfgList, updateRouletteCfg } from '@/api/config/roulette-cfg'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
import { getCacheConfig } from '@/utils'
import { getBuildBoxAllCfg } from '@/api/config/blind-box-cfg'
import { pinata } from '@/api/config/api'
import { getAvatarCfgAll } from '@/api/config/avatar-cfg'
import { getActivityTypeToMap, getPropsActList } from '@/api/config/activity-cfg'
import { comAuxiliary } from '@/api/config/activity-auxiliary-cfg'
export default {
  name: 'RouletteConfig',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      visibleArr: {},
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      rewardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],
      popType: [
        { 'label': '推送更新', value: 1 },
        { 'label': '签到', value: 2 }
      ],
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {},
      skinId: [62, 19, 67, 68],
      shield: [],
      sieve: [],
      chest: [],
      avatar: [],
      animal: [],
      dice: [],
      blindBox: [],
      randMoney: [],
      randSpins: [],
      randDiamond: [],
      randCooperativeCoin: [],
      areaId: [],
      skinMap: {}
    }
  },
  created() {
    this.getSkinInit()
    this.skinMap = {
      19: this.chest,
      23: this.avatar,
      62: this.animal,
      67: this.shield,
      68: this.dice,
      76: this.animal,
      77: this.shield,
      78: this.dice,
      71: this.blindBox,
      82: this.randMoney,
      83: this.randSpins,
      86: this.pinata,
      89: this.randDiamond,
      90: this.randCooperativeCoin,
      101: this.animal,
      102: this.shield,
      103: this.dice,
      104: this.animal,
      105: this.shield,
      106: this.dice
    }
    this.getTables()
    this.getRewardTypeData()
    this.getGroup()
  },
  methods: {
    onSubmit(noTips = false) {
      // const data = JSON.stringify(this.formData)
      // console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          postFormDataCondition[key] = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: scoreItem.group
          }

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }

          const _data = scoreItem.data[0]
          for (const j in _data.reward) {
            const r = _data.reward[j]
            if (r.prize.propsId === 65) {
              _data.reward[j].prize.num *= 10000
            }
          }
          _data.condition = key
          _postData.push(_data)
        }
      }

      console.log(_postData)
      const postCondition = JSON.stringify(postFormDataCondition)
      _postData = JSON.stringify(_postData)
      // console.log(postCondition)
      // console.log(postData)
      updateRouletteCfg({ name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(d, levelName, scoreName, index) {
      this.visibleArr[levelName][scoreName][index].visible = false
    },
    getTables(actName) {
      console.log('actName', actName)
      getRouletteCfgList().then(res => {
        const data = res.data.data
        console.log(data)
        // const tab = {}
        const cond = res.data.cond
        for (const i in cond) {
          const val = cond[i]
          const levelName = val.start + '-' + val.end
          const scoreName = val.groups.join('-')

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.visibleArr, levelName)) {
            this.$set(this.visibleArr, levelName, {})
          }

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          if (!Object.prototype.hasOwnProperty.call(this.visibleArr[levelName], scoreName)) {
            this.$set(this.visibleArr[levelName], scoreName, [])
          }

          // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
          //   this.$set(this.formData[levelName][scoreName], 'data', [])
          // }

          this.$set(this.formData[levelName], scoreName, {
            'group': val.groups,
            'group_name': scoreName,
            'group_bak': val.groups,
            data: []
          })

          for (const ii in data) {
            const _event = data[ii]
            // console.log('ii', _event.condition + ' -- ' + i)
            if (_event.condition === i) {
              for (const j in _event.reward) {
                const r = _event.reward[j]
                if (r.prize.propsId === 65) {
                  _event.reward[j].prize.num /= 10000
                }
              }
              this.visibleArr[levelName][scoreName].push({ visible: false })
              this.$set(this.formData[levelName][scoreName], 'data', [_event])
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }
          console.log('actName', actName)
          if (actName) {
            this.levelActiveName = actName
          } else {
            this.levelActiveName = levelName
          }
        }
      })
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      console.log('old', oldLevelName)
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.visibleArr[oldLevelName]
      Vue.delete(this.visibleArr, oldLevelName)
      this.$set(this.visibleArr, newLevelName, oldVisle)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addEvent(levelName, scoreName) {
      if (this.formData[levelName][scoreName].data.length > 0) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][scoreName].data.push({
        'levelId': 0,
        'condition': '',
        'star': 0,
        'free_time': 0,
        'free_count': 0,
        'skin': '',
        'reward': []
      })
      this.visibleArr[levelName][scoreName].push({ visible: false })
      console.log(this.visibleArr[levelName][scoreName])
    },
    delEvent(levelName, scoreName, index, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$delete(this.formData[levelName], scoreName)
          delRouletteCfgList({ id: id }).then(res => {
            if (res.code === 200) {
              // this.msgSuccess(res.msg)
              this.getTables()
              this.onSubmit(true)
            } else {
              // this.msgError(res.msg)
            }
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      console.log(this.formData[score.level_name])
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })

        this.$set(this.visibleArr[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 弹窗事件
      this.visibleArr[score.level_name][scoreTag].push({ visible: false })
      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({
        'levelId': 0,
        'condition': '',
        'star': 0,
        'free_time': 0,
        'free_count': 0,
        'skin': '',
        'reward': []
      })

      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        this.msgError('等级已经存在')
        return
      }
      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.visibleArr, levelName, {})
      console.log(this.formData)
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(levelName, groupName, index) {
      console.log(this.formData[levelName])
      if (this.formData[levelName][groupName].data[index].reward.length >= 10) {
        this.msgError('已达上限')
        return
      }
      const len = this.formData[levelName][groupName].data[index].reward.length + 1
      this.formData[levelName][groupName].data[index].reward.push(
        { id: len,
          prize:
            { propsId: 1, num: 1, skin: 0, rtype: 1 }, v: 1
        }
      )
    }, delReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].reward = this.formData[levelName][groupName].data[index].reward.filter((item, key) => {
        return key !== i
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.activeName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.visibleArr[levelName][oldGroupName]
      this.$delete(this.visibleArr[levelName], oldGroupName)
      this.$set(this.visibleArr[levelName], newGroupName, oldVisible)
    },
    getSkinInit() {
      getCacheConfig(getBuildBoxAllCfg, 'getBuildBoxAllCfg').then(res => {
        for (const i in res.data) {
          this.blindBox.push({ label: res.data[i].name, value: parseInt(res.data[i].id) })
        }
      })
      getCacheConfig(getAnimalAllList, 'getAnimalAllList').then(res => { this.setConfig(this.animal, res.data) })
      getCacheConfig(getShieldsAllList, 'getShieldsAllList').then(res => { this.setConfig(this.shield, res.data) })
      getCacheConfig(getSieveAllList, 'getDiceAllList').then(res => { this.setConfig(this.dice, res.data) })
      getCacheConfig(getChestCfgAll, 'getChestCfgAll').then(res => {
        for (const i in res.data) {
          this.chest.push({ label: res.data[i].name, value: parseInt(res.data[i].id) })
        }
      })
      getCacheConfig(pinata, 'pinata').then(res => {
        for (const i in res.data) {
          this.pinata.push({ label: res.data[i].name, value: parseInt(res.data[i].id) })
        }
      })
      getCacheConfig(getAvatarCfgAll, 'getAvatarCfgAll').then(res => {
        for (const i in res.data) {
          this.avatar.push({ label: res.data[i].name, value: parseInt(res.data[i].avatar_id) })
        }
      })
      getCacheConfig(getActivityTypeToMap, 'getActivityTypeToMap').then(res => {
        this.activityToType = res.data
        for (const i in res.data) {
          const type = parseInt(i)
          this.activityToTypeId.push(type)
          this.activityList[type] = []
        }
        getCacheConfig(getPropsActList, 'getPropsActList').then(ret => {
          for (const type in ret.data) {
            this.activityList[type] = ret.data[type]
          }
          this.$forceUpdate()
        })
      })

      getCacheConfig(comAuxiliary, 'randSpins', { class: 'randSpins', select: 0 }).then(res => {
        this.loading = false
        const data = res.data
        for (const i in data) {
          const val = data[i]
          for (const k in val) {
            this.randSpins.push({ label: val[k].name, value: parseInt(val[k].id) })
          }
        }
      })

      getCacheConfig(comAuxiliary, 'randMoney', { class: 'randMoney', select: 0 }).then(res => {
        this.loading = false
        const data = res.data
        for (const i in data) {
          const val = data[i]
          for (const k in val) {
            this.randMoney.push({ label: val[k].name, value: parseInt(val[k].id) })
          }
        }
      })

      getCacheConfig(comAuxiliary, 'randMoney', { class: 'randMoney', select: 0 }).then(res => {
        this.loading = false
        const data = res.data
        for (const i in data) {
          const val = data[i]
          for (const k in val) {
            this.randMoney.push({ label: val[k].name, value: parseInt(val[k].id) })
          }
        }
      })

      getCacheConfig(comAuxiliary, 'randDiamond', { class: 'randDiamond', select: 0 }).then(res => {
        this.loading = false
        const data = res.data
        for (const i in data) {
          const val = data[i]
          for (const k in val) {
            this.randDiamond.push({ label: val[k].name, value: parseInt(val[k].id) })
          }
        }
      })

      getCacheConfig(comAuxiliary, 'randCooperativeCoin', { class: 'randCooperativeCoin', select: 0 }).then(res => {
        this.loading = false
        const data = res.data
        for (const i in data) {
          const val = data[i]
          for (const k in val) {
            this.randCooperativeCoin.push({ label: val[k].name, value: parseInt(val[k].id) })
          }
        }
      })
    },
    propChange(v, levelName, groupName, index, i) {
      const record = this.formData[levelName][groupName].data[index].reward[i]
      const typ = parseInt(v)
      record.prize.num = 1
      if (this.skinMap[typ] && this.skinMap[typ].length > 0) {
        record.prize.skin = this.skinMap[typ][0].value
      } else {
        record.prize.skin = 0
      }
      this.formData[levelName][groupName].data[index].reward[i] = record
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getPropName(prodId) {
      let name = ''
      for (const i in this.rewardType) {
        const val = this.rewardType[i]
        if (val.value === prodId) {
          name = val.label
          break
        }
      }
      return name
    },
    getSkinName(propId, skinId) {
      const skinArr = this.skinMap[propId]
      let skin = skinId
      for (const i in skinArr) {
        const val = skinArr[i]
        if (val.value == skinId) {
          skin = val.label
          break
        }
      }
      return skin
    }
  }
}
</script>

<style scoped>
</style>
